module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_eksjo-8d1ac6773ef4481c010763609b3c678f.png";